import React from 'react';
import PropTypes from 'prop-types';
import CurrencyDataPod from '../../../components/CurrencyDataPod';

export default function ApplicationFee({ applicationFee }) {
  const title = 'Application Fees';

  return applicationFee ? (
    <CurrencyDataPod
      header={title}
      ariaLabel={`${title}, $${applicationFee}`}
      content={{
        subTitle: 'Freshman application',
        currencyValues: [applicationFee],
        incomeValues: [],
      }}
    />
  ) : null;
}

ApplicationFee.propTypes = {
  applicationFee: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
